<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="The Firm" src="/images/sub/sub-visual.jpg" />
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first page-section--last">
            <firm-content lang="en" />
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import FirmContent from "@/components/client/firm/firm-content.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        FirmContent,
    },
    props: {},
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>